import * as iFrameResize from 'iframe-resizer/js/iframeResizer.js';

const iframes = [].slice.call(document.querySelectorAll('iframe[data-external]')) as Array<HTMLIFrameElement>;
iframes.forEach(iframe => {
    let iframeSettings = {};
    const iframeSettingsString = iframe.getAttribute('data-external');
    if (iframeSettingsString) {
        let newSettings;
        try {
            newSettings = JSON.parse(`{${iframeSettingsString.replace(/\'/g, '"')}}`);
        } catch (e) {
            console.error(`Custom Iframe options are not correctly formatted, and will be ignored.
            ${e}
            Iframe target: ${iframe.src}`);
        }
        if (newSettings) {
            iframeSettings = newSettings;
        }
    }
    iframeSettings["autoResize"] = true;
    iFrameResize(iframeSettings, iframe);
});